import { useEffect, useMemo } from "react"

import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { tooltipLine } from "../../DashboardPage/components/chartsPlagins"
import { HOME_CHART } from "../redux/home.constants"
import {
  selectHomeChartFilters,
  selectHomePreventedChart,
  selectHomePreventedChartFetching,
  setChartFilters
} from "../redux/home.slice"
import {
  buildComparisonOverlay,
  buildPrimaryDataset,
  homeChartOptions
} from "../utils/chartOptions"
import HomeChartCard from "./HomeChartCard"

const SEGMENTS = [
  { value: "count", label: "Count" },
  { value: "volume", label: "Volume" }
]

// Like the deflected chart, the toggle is a query parameter: the endpoint sends one series, in the
// unit that was asked for, so a flip is a new request rather than a second series in hand.
const PreventedChart = ({ getChartData }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { mode } = useSelector(selectHomeChartFilters(HOME_CHART.PREVENTED))
  const prevented = useSelector(selectHomePreventedChart)
  const fetching = useSelector(selectHomePreventedChartFetching)
  const theme = useSelector((state) => state.nav.theme)

  useEffect(() => {
    getChartData({ chart_type: mode })
  }, [getChartData, mode])

  const isVolume = mode === "volume"

  const data = useMemo(() => {
    const labels = prevented?.labels ?? []
    const comparison = prevented?.comparison

    return {
      labels,
      datasets: [
        buildPrimaryDataset({
          label: t("Chargebacks prevented"),
          data: prevented?.result?.data ?? [],
          pointCount: labels.length
        }),
        ...buildComparisonOverlay({
          labels,
          series: comparison?.result?.data,
          comparisonLabels: comparison?.labels,
          label: prevented?.comparison_period?.label || t("previous period")
        })
      ]
    }
  }, [prevented, t])

  const options = useMemo(
    () => homeChartOptions({ theme, title: t("Chargebacks prevented"), isCurrency: isVolume }),
    [theme, isVolume, t]
  )

  return (
    <HomeChartCard
      testId="home-chart-prevented"
      icon="alerts"
      title="Chargebacks prevented"
      segments={SEGMENTS}
      activeSegment={mode}
      onSegmentChange={(value) =>
        dispatch(setChartFilters({ chart: HOME_CHART.PREVENTED, filters: { mode: value } }))
      }
      data={data}
      options={options}
      plugins={[tooltipLine]}
      loading={fetching}
    />
  )
}

export default PreventedChart
